module.exports = __webpack_public_path__ + "static/media/saveBookmark.305797c1.png";